module.exports = __webpack_public_path__ + "img/cm_s3-slc1-u.ba287476.png";